export const imageUrl = path => "https://nocturnal-unrest.de" + path

export const fileUrl = path => "https://nocturnal-unrest.de" + path